module.exports = __webpack_public_path__ + "static/media/list.bf113fad.svg";